import { setCookieOnDomain } from './cookies'
import { READER_V2_PATH } from '../config/vars'
import Url from './url'
import client from 'api/client'
import { markBookAsVisibleMutation } from 'api/mutations'

const FULL_PATH_TO_READER = ({ slug }: { slug: string }) => {
  return `${READER_V2_PATH}/?slug=${slug}`
}

const FULL_PATH_TO_SHARE_READING = (slug: string, sharedReadingId: number) =>
  `${FULL_PATH_TO_READER({
    slug
  })}&shared_reading_id=${sharedReadingId}`

const COOKIE_EXPIRATION = Number((1 / (24 * 60)).toFixed(6)) // 1 minute

const markBookAsVisible = (bookSlug: string) => {
  return client.mutate({
    mutation: markBookAsVisibleMutation,
    variables: {
      bookSlug
    }
  })
}

export const open = async (
  bookSlug: string,
  sharedReadingId?: number,
  searchParams?: { [key: string]: string | number | boolean }
) => {
  markBookAsVisible(bookSlug)

  setCookieOnDomain('Client', 'BROWSER', COOKIE_EXPIRATION)

  let bookUrl: string

  if (!sharedReadingId) {
    bookUrl = FULL_PATH_TO_READER({
      slug: bookSlug
    })
  } else {
    bookUrl = FULL_PATH_TO_SHARE_READING(bookSlug, sharedReadingId)
  }

  if (!searchParams) {
    Url.set(bookUrl)
  } else {
    const urlParams = new URLSearchParams()
    Object.entries(searchParams).forEach(entry => {
      urlParams.set(entry[0], String(entry[1]))
    })
    Url.set(!searchParams ? bookUrl : `${bookUrl}&${urlParams.toString()}`)
  }
}

export const openMaterial = (materialId: number, title: string) => {
  setCookieOnDomain('Client', 'BROWSER', COOKIE_EXPIRATION)

  const params = new URLSearchParams({
    material: String(materialId),
    title
  })

  Url.set(`${READER_V2_PATH}/?${params.toString()}`)
}

export default {
  open,
  openMaterial
}
